// src/pages/CreateSession.js

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../api";

export default function CreateSession() {

  const [name, setName] = useState("");
  const [gender, setGender] = useState("unspecified");
  const [language, setLanguage] = useState("en");
  const [code, setCode] = useState(null);

  const text =
    "You are about to create a shared space for reflection.\n\n" +
    "This first step focuses on you — as an individual.\n" +
    "It will guide you through a short set of personal questions, helping ReflectUS understand you more clearly.\n\n" +
    "Once the session is created, you will receive a private code.\n" +
    "Share this code with your partner, and they will be able to join the session and begin the process with you.\n\n" +
    "A calm beginning — before the shared reflection unfolds.";

  const [typed, setTyped] = useState("");
  const [i, setI] = useState(0);

  useEffect(() => {
    if (i < text.length) {
      const t = setTimeout(() => {
        setTyped(prev => prev + text[i]);
        setI(i + 1);
      }, 32);
      return () => clearTimeout(t);
    }
  }, [i, text]);

  const navigate = useNavigate();

  async function create() {

    if (!name) return alert("Please enter your name.");

    try {

      const res = await fetch(`${API_BASE}/create_session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          creator_name: name,
          gender,
          language
        })
      });

      const data = await res.json();

      if (data.session_id) {

        setCode(data.session_id);

        localStorage.setItem("session_id", data.session_id);
        localStorage.setItem("role", "A");
        localStorage.setItem("name", name);
        localStorage.setItem("gender", gender);
        localStorage.setItem("language", language);
      }

    } catch {
      alert("Could not reach backend");
    }
  }

  function copyCode() {
    navigator.clipboard.writeText(code);
    alert("Code copied");
  }

  return (

    <div
      className="fade-in"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",
        paddingTop: 80
      }}
    >

      {/* INTRO TEXT */}

      <div
        style={{
          maxWidth: 520,
          margin: "0 auto 36px",
          minHeight: 560,

          fontFamily: "Cormorant Garamond, serif",
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 1.9,
          letterSpacing: "0.04em",

          color: "#F5F4ED",

          whiteSpace: "pre-wrap"
        }}
      >
        {typed}
      </div>

      {/* FORM CARD */}

      <div
        className="card form"
        style={{
          backdropFilter: "blur(8px)",
          background: "rgba(18,48,68,0.35)",
          border: "1px solid rgba(245,244,237,0.25)",
          boxShadow: "0 0 18px rgba(0,0,0,0.25)"
        }}
      >

        <input
          className="input"
          placeholder="Your display name"
          value={name}
          onChange={e => setName(e.target.value)}
        />

        <select
          value={gender}
          onChange={e => setGender(e.target.value)}
          className="input"
        >
          <option value="unspecified">Prefer not to say</option>
          <option value="female">Female</option>
          <option value="male">Male</option>
        </select>

        <select
          value={language}
          onChange={e => setLanguage(e.target.value)}
          className="input"
          style={{ marginTop: 14 }}
        >
          <option value="en">English</option>
          <option value="sl">Slovenščina</option>
          <option value="de">Deutsch</option>
          <option value="fr">Français</option>
        </select>

        <div style={{ marginTop: 18 }}>
          <button className="btn btn-primary" onClick={create}>
            Create session
          </button>
        </div>

        {code && (

          <div style={{ marginTop: 22 }}>

            <div className="code-box">{code}</div>

            <div style={{ display: "flex", gap: 12, marginTop: 14 }}>

              <button className="btn btn-ghost" onClick={copyCode}>
                Copy code
              </button>

              <button
                className="btn btn-primary"
                onClick={() => navigate(`/onboarding/${code}/A`)}
              >
                Continue
              </button>

            </div>

          </div>

        )}

      </div>

    </div>
  );
} 
